import { render, staticRenderFns } from "./tableLoading.vue?vue&type=template&id=570e027a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e027a",
  null
  
)

export default component.exports